import * as React from 'react'
import {observer} from 'mobx-react'
import {CSSTransition} from 'react-transition-group'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {SubscriptionPaymentMethods} from '../elements/SubscriptionPaymentMethods'
import {SubscriptionPaymentMethodDetails} from '../elements/SubscriptionPaymentMethodDetails'
import {FooterInfo} from '../elements/FooterInfo'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionPaymentMethodUpdateBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  let blockId = api.ui.generateUniqueElementId('payment-methods-')
  let {uiTransitionTimeout: timeout} = api.computedConfig

  let form
  let isPaymentMethodSelected = false

  if (api.subscriptionInfo) {
    form = api.subscriptionRenewForm
  }

  if (api.epmsSubscriptionInfo) {
    form = api.paymentForm
  }

  isPaymentMethodSelected = !!form.getPaymentMethod()

  return (
    <section
      id={blockId}
      className="widget-block subscription-payment-method-update-block"
    >
      <div className="widget-block-header">
        <div className="title">
          <h2 className="text">
            {api.trans('blocks.subscription_payment_method_update.title')}
          </h2>
        </div>
      </div>

      <div className="widget-block-content">
        <fieldset>
          <legend>
            {api.trans('blocks.subscription_payment_method_update.legend')}
          </legend>

          <CSSTransition
            in={!isPaymentMethodSelected}
            mountOnEnter
            unmountOnExit
            timeout={timeout}
            classNames="swap-down"
          >
            <SubscriptionPaymentMethods topElementId={blockId} />
          </CSSTransition>

          <CSSTransition
            in={isPaymentMethodSelected}
            mountOnEnter
            unmountOnExit
            timeout={timeout}
            classNames="swap-up"
          >
            <SubscriptionPaymentMethodDetails topElementId={blockId} />
          </CSSTransition>
        </fieldset>
      </div>
      <FooterInfo />
    </section>
  )
})
